<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách vật tư theo kho</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryId"
              :options="optionType"
              placeholder="Tên vật tư"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="warehouseSearch.region"
              :options="optionRegion"
              placeholder="Vùng"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="warehouseSearch.level"
              :options="optionLevel"
              :settings="{ placeholder: 'Cấp kho' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="warehouseSearch.inventories"
              :options="optionInventory"
              placeholder="Tên kho"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.managerId"
              :options="optionStaff"
              placeholder="Người quản lý"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :options="optionStaff"
              placeholder="Thủ kho"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            Tổng: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataDevice"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(availableQuantity)="data">
                {{ data.item.quantity - data.item.lockedQuantity }}
              </template>
              <template #cell(keeper)="data">
                <div v-if="data.item.keeper">
                  {{ data.item.keeper.name }} <br />
                  <span class="text-primary">{{ data.item.keeper.email }}</span>
                </div>
                <div v-else></div>
              </template>
              <template #cell(manager)="data">
                <div v-if="data.item.manager">
                  {{ data.item.manager.name }}
                </div>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="onRowSelected(data.item)"> Chi tiết </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="fl-right col-sm-4"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'inventoryName', label: 'Tên kho' },
    { key: 'categoryName', label: 'Tên vật tư' },
    { key: 'quantity', label: 'Tổng số lượng' },
    { key: 'availableQuantity', label: 'Số lượng khả dụng' },
    { key: 'manager', label: 'Người quản lý' },
    { key: 'keeper', label: 'Thủ kho' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'list-material-status',
    mixins: [prepareQueryParamsMixin],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataDevice ? this.selected.length === this.dataDevice.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataDevice.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'warehouseSearch.region': function () {
        this.testing()
      },
      'warehouseSearch.level': function () {
        if (this.warehouseSearch.level.length === 0) {
          delete this.warehouseSearch.level
        }
        this.testing()
      },
    },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        loading: false,
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        optionLevel: Config.levelWarehouse,
        optionStatus: Config.statusDevices,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStaff: [],
        optionRegion: [],
        optionInventory: [],
        copy: [],
        warehouseSearch: {},
        dataDevice: [],
        search: {
          limit: 20,
          page: 1,
          kind: 'NORMAL',
        },
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        pagination: {
          total: 0,
        },
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        optionType: [],
        hasDefaultFilter: true,
      }
    },
    created() {
      this.getListStaff()
      this.getListRegion()
      this.getListInventory()
      this.transformDate()
      this.fetchData()
      this.typeDeviceConfig()
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      async testing() {
        try {
          this.showLoading = true
          this.optionInventory = this.copy
          if (this.checkSelect(this.warehouseSearch.region)) {
            await this.listStaffRegion([this.warehouseSearch.region])
            this.optionInventory = this.optionInventory.filter(
              el => el.regions !== null && el.regions.includes(this.warehouseSearch.region)
            )
          } else {
            delete this.warehouseSearch.region
          }
          if (this.checkSelect(this.warehouseSearch.level)) {
            this.optionInventory = this.optionInventory.filter(
              el => el.level !== null && this.warehouseSearch.level.includes(el.level)
            )
          } else {
            delete this.warehouseSearch.level
          }
        } catch (error) {
        } finally {
          this.showLoading = false
        }
      },
      onRowSelected(item) {
        window.open(`/material/warehouse/${item.id}`, '_blank')
      },
      async getListStaff() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.success) {
            this.optionStaff = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.userName} - ${e.name}`,
              }
            })
            this.optionStaff.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async listStaffRegion(regionList) {
        try {
          const data = await StaffService.getListLowerGrade({
            userId: this.dataUser.userId,
            region: regionList,
          })
          this.optionStaff = data.data.map(e => {
            return { id: e.id, text: `${e.name} - ${e.userName}` }
          })
        } catch (e) {
          console.error(e)
        }
      },
      async getListRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            const body = data.data.map(e => {
              return {
                ...e,
                text: e.name,
              }
            })
            body.unshift({ id: '0', text: 'Tất cả', regions: [], level: '' })
            this.optionInventory = [...body]
            this.copy = [...body]
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkSelect(sel) {
        if (sel !== '0' && sel !== undefined) {
          return true
        } else {
          return false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          kind: 'NORMAL',
        }
        this.warehouseSearch = {}
        this.selected = []
        this.optionInventory = this.copy
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.search = {
          limit: 20,
          page: 1,
          kind: 'NORMAL',
        }
        this.warehouseSearch = {}
        this.selected = []
        this.optionInventory = this.copy
        this.dateRange = { startDate: null, endDate: null }
        this.hasDefaultFilter = false
        this.fetchData()
      },

      async fetchData() {
        try {
          this.loading = true
          if (this.search.categoryId === '0') delete this.search.categoryId
          if (this.search.managerId === '0') delete this.search.managerId
          if (this.search.keeperId === '0') delete this.search.keeperId
          if (this.checkSelect(this.warehouseSearch.inventories)) {
            this.search.inventoryIds = [this.warehouseSearch.inventories]
          } else {
            if (
              this.warehouseSearch.region !== undefined ||
              this.warehouseSearch.level !== undefined
            ) {
              const idInventory = this.optionInventory.map(e => e.id)
              this.search.inventoryIds = idInventory
            } else {
              delete this.search.inventoryIds
            }
          }
          await this.listDeviceStatus()
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async listDeviceStatus() {
        const data = await DeviceService.listDevice(this.search)
        if (data.success) {
          this.dataDevice = data.data.devices || []
          this.pagination.total = data.data.count ? data.data.count : 0
        }
      },
      async typeDeviceConfig() {
        try {
          const params = {
            kind: 'NORMAL',
          }
          const data = await DeviceService.deviceKindNomal(params)
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // async exportExcel () {
      //   try {
      //     this.showLoading = true
      //     const req = { ...this.search }
      //     delete req.page
      //     delete req.limit
      //     if (this.dataDevice.length > 0) {
      //       const data = await DeviceService.exportDevice(req)
      //       if (data.success) {
      //         this.notiModal = true
      //         this.iconNoti = require('@/assets/img/noti-success2.svg')
      //         this.msgNoti = 'Dữ liệu sẽ được gửi đến email của bạn sau ít phút, vui lòng kiểm tra email cá nhân'
      //       } else {
      //         this.notiModal = true
      //         this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      //         this.msgNoti = data.message
      //       }
      //     } else {
      //       this.notiModal = true
      //       this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      //       this.msgNoti = 'Không có dữ liệu để xuất'
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.showLoading = false
      //   }
      // }
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }

  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
</style>
